import { Pipe, PipeTransform } from '@angular/core';

/**
 * Index Of Pipe
 *
 * Pure pipe that finds the index of a value within an array.
 * Using this pipe is preferable to calling array.indexOf inside a template
 * because this pipe only executes when one of the inputs changes. The object reference of the
 * input array must be changed in order to trigger execution. Adding items to the input array will
 * not cause the pipe to run again.
 */
@Pipe({
    standalone: false,
    name: 'indexOf',
})
export class IndexOfPipe implements PipeTransform {
    transform(array: any[] | string, value: any): number {
        return array.indexOf(value);
    }
}
